import {
  createReducer,
  createFetchReducers,
  createFetchActionForNamespace,
  createFetchSelectors,
  noDataForAction
} from 'utils/reducers';

const createFetchAction = createFetchActionForNamespace('locations/list');
const LOCATIONS_STATE_KEY = 'locations';

export const fetchLocations = createFetchAction({
  name: 'FETCH_LOCATIONS',
  initialAction: noDataForAction,
  stateKey: LOCATIONS_STATE_KEY,
  defaultStateValue: []
});

const fetchLocationsSelectors = createFetchSelectors(fetchLocations);

export const selectLocations = fetchLocationsSelectors.data;

const reducer = createReducer(
  {},
  {
    ...createFetchReducers(fetchLocations)
  }
);

export default reducer;

export {default as locationListSaga} from './saga';
